import { render, staticRenderFns } from "./multimedia.vue?vue&type=template&id=1c818552&scoped=true&"
import script from "./multimedia.vue?vue&type=script&lang=js&"
export * from "./multimedia.vue?vue&type=script&lang=js&"
import style0 from "./multimedia.vue?vue&type=style&index=0&id=1c818552&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c818552",
  null
  
)

export default component.exports